import React from 'react';

import type { BaseComponentProps } from '@coursera/cds-common';

import getContentCss from './styles/getContentCss';

export type Props = BaseComponentProps<'div'>;

const Content = React.forwardRef(function Content(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} css={getContentCss} {...rest}>
      {children}
    </div>
  );
});

if (__DEV__) {
  Content.displayName = 'TemporaryDrawer.Content';
}

export default Content;
